/*
  © 2024–2026 Atlas PHM
  Independently developed software. All rights reserved.
*/

/**
 * Priority options for upgrade decisions
 * These align with the PriorityKey type from @core/types
 */

import type { PriorityOption } from '@decision-ui/components/shared/PrioritiesPicker';

export const PRIORITY_OPTIONS: PriorityOption[] = [
  {
    key: 'low_upfront_cost',
    label: 'Low upfront cost',
    description: 'Minimize initial installation expense',
  },
  {
    key: 'low_running_cost',
    label: 'Low running costs',
    description: 'Reduce ongoing energy bills',
  },
  {
    key: 'hot_water_performance',
    label: 'Hot water performance',
    description: 'Strong flow rates and quick recovery',
  },
  {
    key: 'reliability_simplicity',
    label: 'Reliability & simplicity',
    description: 'Proven, low-maintenance systems',
  },
  {
    key: 'quiet_operation',
    label: 'Quiet operation',
    description: 'Minimal noise during use',
  },
  {
    key: 'future_proofing',
    label: 'Future-proofing',
    description: 'Ready for changing regulations and tech',
  },
  {
    key: 'minimal_disruption',
    label: 'Minimal disruption',
    description: 'Quick installation with less upheaval',
  },
  {
    key: 'smart_controls',
    label: 'Smart controls',
    description: 'Advanced heating management and scheduling',
  },
  {
    key: 'environmental_impact',
    label: 'Environmental impact',
    description: 'Lower carbon emissions',
  },
  {
    key: 'comfort_even_heat',
    label: 'Comfort & even heat',
    description: 'Consistent warmth throughout the home',
  },
];
